import { gql } from '@apollo/client';

export const REVIEW_TOOL_BOOKING = gql`
  mutation ReviewToolBooking($id: ID!, $rating: Int!, $comment: String) {
    reviewToolBooking(input: { id: $id, rating: $rating, comment: $comment }) {
      toolBooking {
        id
        status
        fromDate
        toDate
      }
      errors
    }
  }
`;

export const REVIEW_TOOL_BOOKING_DIRECT = gql`
  mutation ReviewToolBookingDirect($id: ID!, $rating: Int!, $comment: String) {
    reviewToolBooking(id: $id, rating: $rating, comment: $comment) {
      toolBooking {
        id
        status
        fromDate
        toDate
      }
      errors
    }
  }
`;

export const COMPLETE_TOOL_BOOKING_WITH_REVIEW = gql`
  mutation CompleteToolBookingWithReview($id: ID!, $rating: Int!, $comment: String, $message: String) {
    completeToolBooking(input: { id: $id, rating: $rating, comment: $comment, message: $message }) {
      toolBooking {
        id
        status
        fromDate
        toDate
      }
      errors
    }
  }
`;

export const COMPLETE_TOOL_BOOKING_DIRECT_WITH_REVIEW = gql`
  mutation CompleteToolBookingDirectWithReview($id: ID!, $rating: Int!, $comment: String, $message: String) {
    completeToolBooking(id: $id, rating: $rating, comment: $comment, message: $message) {
      toolBooking {
        id
        status
        fromDate
        toDate
      }
      errors
    }
  }
`;
